import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { BrowserQRCodeSvgWriter } from '@zxing/browser';
import { debounceTime } from 'rxjs/operators';
import { PaymentQrModel } from 'src/app/core/models/payment-qr.model';
import { IdentityService } from 'src/app/core/services/identity.service';
import { MyCommerceService } from 'src/app/core/services/my-commerce.service';
import { UserService } from 'src/app/core/services/user.services';
import { CurrencyValidatorDirective } from 'src/app/shared/directives/currency-validator.directive';
import { currencyToNumber } from 'src/app/shared/functions/currency.functions';
import { IOptionsNgSelect } from 'src/app/shared/interfaces/ioptionsNgSelect';
import { PayService } from 'src/app/core/services/pay.service';
import { CashierItemModel } from 'src/app/core/models/cashierItem.model';
import { Router } from '@angular/router';
import * as svg from 'save-svg-as-png';
import { PaymentsService } from 'src/app/core/services/payments.service';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-pay-order',
  templateUrl: './pay-order.component.html',
  styleUrls: ['./pay-order.component.scss']
})
export class PayOrderComponent implements OnInit {
  @ViewChild('branchMatSelect') selectBranch: MatSelect;
  @ViewChild('cashierMatSelect') selectCashier: MatSelect;
  @ViewChild(CurrencyValidatorDirective) currencyValidatorDirective: CurrencyValidatorDirective;
  @ViewChild('inputCash') inputCash: ElementRef;
  @ViewChild('myTooltip') myInfoTooltip: MatTooltip;

  montoValid: boolean = false;
  cashOutInputCurrency: string = '$0,00';
  form: UntypedFormGroup;

  qrGenerator: BrowserQRCodeSvgWriter;
  generateQr: boolean = false;
  public QRimgSrc: string = '';

  oneBranch: boolean = false;
  oneCashier: boolean = false;

  commerceUser: boolean = true;
  userResponsible: boolean = true;
  monto = 0;

  branchOfficesCollection: IOptionsNgSelect[];
  branchFilter: IOptionsNgSelect[];
  branchOfficeSelect: number[];
  sucursalActual = null;

  cashierCollection: IOptionsNgSelect[];
  cashierFilter: IOptionsNgSelect[];
  cajaActual;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private identity: IdentityService,
    private translateService: TranslateService,
    private myCommerceService: MyCommerceService,
    private payService: PayService,
    private router: Router,
    private paymentsService: PaymentsService
  ) {
    this.qrGenerator = new BrowserQRCodeSvgWriter();
  }

  get branchSelected() {
    return this.form.get('branchSelected');
  }

  get cashierSelected() {
    return this.form.get('cashierSelected');
  }

  get formMonto() {
    return this.form.get('monto');
  }

  montoDown: boolean = true;
  errorIndex = 0;

  async ngOnInit() {
    this.form = this.formBuilder.group({
      concept: new UntypedFormControl(null, { updateOn: 'blur' }),
      monto: new UntypedFormControl('', { validators: [Validators.required] }),
      searchBranch: new UntypedFormControl(''),
      searchCashier: new UntypedFormControl(''),
      branchSelected: new UntypedFormControl('', Validators.required),
      cashierSelected: new UntypedFormControl('', Validators.required)
    });

    this.commerceUser = this.identity.isCommerce();
    this.userResponsible = this.identity.isRolResponsible();

    if (this.commerceUser || this.userResponsible) {
      await this.loadChashier();
      await this.loadbranchOffices();
    }

    this.form
      .get('searchBranch')
      .valueChanges.pipe(debounceTime(150))
      .subscribe((value) => {
        value
          ? (this.branchFilter = this.branchOfficesCollection.filter((branch) =>
              branch.display.toUpperCase().includes(value.toUpperCase())
            ))
          : (this.branchFilter = this.branchOfficesCollection);
      });

    this.form
      .get('searchCashier')
      .valueChanges.pipe(debounceTime(150))
      .subscribe((value) => {
        value
          ? (this.cashierFilter = this.cashierCollection.filter((cashier) =>
              cashier.display.toUpperCase().includes(value.toUpperCase())
            ))
          : (this.cashierFilter = this.cashierCollection);
      });

    setTimeout((x) => {
      this.form.controls['monto'].setValue(this.cashOutInputCurrency);
    }, 300);
    this.formMonto.valueChanges.subscribe((value) => {
      let amountNumeric = currencyToNumber(value);
      if (amountNumeric > 0) {
        this.montoDown = true;
        this.formMonto.setErrors({});
        this.formMonto.updateValueAndValidity({ onlySelf: false, emitEvent: false });
      } else {
        this.montoDown = false;
        this.errorIndex = 2;
        this.formMonto.setErrors({ incorrect: true });
      }
      this.validarForm(amountNumeric);
    });
  }

  keyPressNumbers(event) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  getErrorMessage(valueError: number) {
    switch (valueError) {
      case 1:
        return this.translate('dialog_cash.labels.validations.amount_major_than_available');
      case 2:
        return this.translate('dialog_cash.labels.validations.amount_zero');
      case 6:
        return this.translate('dialog_cash.labels.validations.amount_required');
      default:
        return '';
    }
  }

  currencyInputChanged(value) {
    if (value == '' && this.inputCash) {
      this.inputCash.nativeElement.value = 0;
      this.monto = 0;
    }
    if (value) {
      if (value.toString().indexOf(',') >= 0) value = value.replace(',', '.');
      if (value.toString().indexOf(/[$,]/g) >= 0) value = value.replace(/[$,]/g, '');
      var num = value;
      this.monto = Number(num);
    } else {
      this.monto = 0;
    }
  }

  validarForm(monto) {
    monto = monto <= 0 || isNaN(monto) ? (this.montoValid = false) : (this.montoValid = true);
  }

  private loadbranchOffices() {
    this.userService.getBranchOfficesCollection().then((officeBranches) => {
      this.branchOfficesCollection = Array<IOptionsNgSelect>();
      officeBranches.forEach((ob) => {
        const opt = { value: ob.id, display: ob.name, type: ob.name };
        this.branchOfficesCollection.push(opt as IOptionsNgSelect);
      });
      this.branchFilter = this.branchOfficesCollection;
      if (this.branchFilter.length <= 1) {
        this.oneBranch = true;
        this.sucursalActual = this.branchFilter[0].value;
      }
    });
  }

  private loadChashier() {
    this.userService.getCashiers().then((cashier) => {
      this.cashierCollection = Array<IOptionsNgSelect>();
      cashier.forEach((ob) => {
        if (this.branchOfficeSelect) {
          if (this.branchOfficeSelect.includes(ob.branchOffice.id)) {
            const opt = { value: ob.id, display: ob.name, type: ob.name };
            this.cashierCollection.push(opt as IOptionsNgSelect);
          }
        } else {
          const opt = { value: ob.id, display: ob.name, type: ob.name };
          this.cashierCollection.push(opt as IOptionsNgSelect);
        }
      });
      this.cashierFilter = this.cashierCollection;
      if (this.cashierFilter.length <= 1) {
        this.cashierQrGenerated = this.cashierFilter;
        this.oneCashier = true;
      }
    });
  }

  selectionChangeCashier() {
    this.cajaActual = this.selectCashier.value;
    this.form.get('cashierSelected').setValue(this.cajaActual);
  }

  async viewBranch(branch) {
    this.cashierCollection = Array<IOptionsNgSelect>();
    let branchData = await this.myCommerceService.getSucursal(branch.value.toString());
    branchData.cajas.forEach((ob) => {
      const opt = { value: ob.id, display: ob.nombre, type: ob.nombre };
      this.cashierCollection.push(opt as IOptionsNgSelect);
    });

    this.cashierFilter = this.cashierCollection;
    this.cashierQrGenerated = this.cashierFilter;
    if (this.cashierFilter.length <= 1) {
      this.oneCashier = true;
      this.cashierSelected.setValue(this.cashierFilter[0].display);
    } else {
      this.oneCashier = false;
    }
  }

  selectionChangeBranch() {
    this.sucursalActual = this.selectBranch.value;
    this.form.get('branchSelected').setValue(this.sucursalActual);
  }

  cashierQrGenerated: any;
  loadingCashierName: boolean = false;

  async continuePayment(form) {
    let request = new PaymentQrModel();
    this.generateQr = true;
    this.cashOutInputCurrency = this.currencyValidatorDirective.output;
    if (this.oneCashier) {
      request.cashierCode = this.cashierFilter[0].value;
    } else {
      request.cashierCode = this.cashierSelected.value;
    }
    let d = new Date();
    d.setMinutes(d.getMinutes() + 5);
    request.expirationTime = d;
    if (this.oneBranch) {
      request.branchOfficeCode = this.branchFilter[0].value;
    } else {
      request.branchOfficeCode = this.branchSelected.value;
    }
    request.items = [new CashierItemModel(form.value.concept, 1, currencyToNumber(this.cashOutInputCurrency))];
    this.loadingCashierName = true;
    await this.payService.createPaymentOrderQr(request);
    let cajaNombre = this.cashierQrGenerated.filter((x) => x.value == request.cashierCode);
    this.cashierQrGenerated = cajaNombre[0].display;
    this.loadingCashierName = false;
    await this.generateQR(request.branchOfficeCode, request.cashierCode);
  }

  @ViewChild('userQRCont') userQRCont: ElementRef;
  async generateQR(sucursalId: number, cajaId: number) {
    let doc = (document.getElementById('userQR').innerHTML = '');
    const qrResponse = await this.paymentsService.getQREMVco(sucursalId, cajaId);
    if (qrResponse) {
      this.qrGenerator.writeToDom('#userQR', qrResponse, 380, 380);
      this.QRimgSrc = await svg.svgAsPngUri(this.userQRCont.nativeElement.children[0], { backgroundColor: 'white' });
    }
  }

  async newQr() {
    this.generateQr = false;
    this.branchOfficeSelect = null;
    this.oneCashier = false;
    this.oneBranch = false;
    this.branchSelected.reset();
    this.cashierSelected.reset();
    this.sucursalActual = null;
    this.cashOutInputCurrency = '$0,00';
    this.cashierQrGenerated = '';
    await this.loadbranchOffices();
    await this.loadChashier();
  }

  public translate(key: string): string {
    return this.translateService.instant(key);
  }

  goBack() {
    this.router.navigate([localStorage.getItem('url')]);
  }

  navigate(url: string) {
    this.router.navigate([url]);
  }
}
